import React, { useContext, useState } from 'react'

const NavigationContext = React.createContext()

export const NavigationProvider = ({ children }) => {
  const [showContentContainer, setShowContentContainer] = useState(true)
  const [showSidebar, setShowSidebar] = useState(true)
  const [sidebarRetracted, setSidebarRetracted] = useState(false)
  const [sectionIndex, setSectionIndex] = useState(0)
  const [removePadding, setRemovePadding] = useState(false)
  const [removeOverflow, setRemoveOverflow] = useState(false)

  return (
    <NavigationContext.Provider
      value={{
        showContentContainer,
        setShowContentContainer,
        showSidebar,
        setShowSidebar,
        sidebarRetracted,
        setSidebarRetracted,
        sectionIndex,
        setSectionIndex,
        removePadding,
        setRemovePadding,
        removeOverflow,
        setRemoveOverflow,
      }}
    >
      {children}
    </NavigationContext.Provider>
  )
}

export const useNavigationContext = () => {
  const value = useContext(NavigationContext)
  return value
}

export default NavigationContext
